import Badge from './badge';

export default Badge;
export type * from './types';
